export default __webpack_public_path__ + "assets/images/4ae49ddccdb4d44b232c0518a34af8aa.svg";